// extracted by mini-css-extract-plugin
export default {"MasterFileIndex":"MasterFileIndex_MasterFileIndex__yvyKS"};